import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const RecoveryConcepts = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Query: Recovery Concepts: Log Based Recovery Protocols, Recovery based on deferred update, Recovery techniques based on immediate update – Shadow Paging Algorithm"
    videos={[
      "https://www.youtube.com/embed/47LvbDGD4cc",
      "https://www.youtube.com/embed/0YhOYqPeq0g",
      "https://www.youtube.com/embed/HnVo3_iH76w",
      "https://www.youtube.com/embed/495q-pDJ9zE"
    ]}
    takeaways={[]}
    questions={[
      "Describe the shadow paging recovery technique.",
      "Elaborate on recovery techniques (deferred and immediate) for single and multi-user transactions"
    ]}
    exampleVideos={[]}
  />
);
}

export default RecoveryConcepts;
